export enum CatalogMutationTypes {
    RESET = "RESET",
    SET_UNIVERSES = "SET_UNIVERSES",
    SET_CATEGORIES = "SET_CATEGORIES",
    SET_PRODUCTS = "SET_PRODUCTS",
    SET_HISTORY = "SET_HISTORY",
    SET_ACTIVE_PRODUCT_SLUG = "SET_ACTIVE_PRODUCT_SLUG"
}
